import { AxiosError, AxiosHeaders, type AxiosInstance, type AxiosResponse, type InternalAxiosRequestConfig } from 'axios';
import type { Promisable } from 'type-fest';

export type HttpInterceptorOptions = {
  xAmministroProfile: (() => string | null | undefined);
  jwt: (() => Promisable<string | null | undefined>);
  signOut: () => Promise<void>;
};

const INVALID_PROFILE_STATUS = 412;

export class HttpInterceptorsService {
  readonly http: AxiosInstance;

  readonly xAmministroProfile: (() => string | null | undefined);
  readonly jwt: (() => Promisable<string | null | undefined>);
  readonly signOut: (() => Promise<void>);

  constructor(axios: AxiosInstance, options: HttpInterceptorOptions) {
    this.http = axios;

    this.xAmministroProfile = options.xAmministroProfile;
    this.jwt = options.jwt;
    this.signOut = options.signOut;

    this.http.interceptors.request.use(
      this.onRequestSuccessInterceptor.bind(this),
      this.onRequestErrorInterceptor.bind(this),
    );

    this.http.interceptors.response.use(
      this.onResponseSuccessInterceptor.bind(this),
      this.onResponseErrorInterceptor.bind(this),
    );
  }

  onRequestErrorInterceptor(err: unknown) {
    console.error(err);
    return err;
  }

  async onRequestSuccessInterceptor(config: InternalAxiosRequestConfig) {
    const xAmministroProfile = this.xAmministroProfile() || null;
    const jwt = (await this.jwt()) || null;

    config.headers = new AxiosHeaders({
      'xAmministroProfile': xAmministroProfile,
      'Authorization': config.headers.Authorization ?? jwt ? `Bearer ${jwt}` : null,
      'access-control-allow-origin': '*',
      ...config.headers,
    });

    return config;
  }

  onResponseSuccessInterceptor(res: AxiosResponse) {
    // @ts-expect-error Property 'includes' does not exist on type 'string | number | boolean | AxiosHeaders | string[]'. Property 'includes' does not exist on type 'number'.
    if (!res.headers['content-type']?.includes('application/json')) return res;
    if (!res.data) return res;
    if (typeof res.data !== 'object') return res;

    return res.data;
  }

  onResponseErrorInterceptor(error: unknown) {
    if (!(error instanceof AxiosError)) throw error;

    const { status } = error.response || {};
    if (status === INVALID_PROFILE_STATUS) return this.signOut(); // ? capire se serve che sia async

    throw error;
  }
}
